import React                     from 'react';
import { Route, Routes }                 from 'react-router-dom';
import { AcceptInvitation }      from './AcceptInvitation/AcceptInvitation';
import { Confirmation }          from './Confirmation/Confirmation';
import { CreateFamily }          from './CreateFamily/CreateFamily';
import { CreatePin }             from './CreatePin/CreatePin';
import { CustomizeProfile }      from './CustomizeProfile';
import { ForgotPassword }        from './ForgotPassword/ForgotPassword';
import { ResetPassword }         from './ResetPassword/ResetPassword';
import { SignInUpPage }          from './shared/styles';
import { SignIn }                from './SignIn/SignIn';
import { SignUp }                from './SignUp/SignUp';
import { SelectFamilyComponent } from './SelectFamilyComponent/SelectFamilyComponent';
import { ChangeSubscription }    from './ChangeSubscription/ChangeSubscription';
import { NotFound }              from '../shared/components/NotFound';

const Checkout = React.lazy(() => import('./Checkout/Checkout'));

export const AuthRoutes = () => (
  <SignInUpPage>
    <Routes>
      <Route
        path="sign-up"
        element={<SignUp />}
      />

      <Route
        path="sign-in"
        element={<SignIn />}
      />

      <Route
        path="forgot-password"
        element={<ForgotPassword />}
      />

      <Route
        path="accept-invitation"
        element={<AcceptInvitation />}
      />

      <Route
        path="reset-password"
        element={<ResetPassword />}
      />

      <Route
        path="confirmation"
        element={<Confirmation />}
      />

      <Route
        path="confirm-email"
        element={<Confirmation />}
      />

      <Route
        path="confirm-change-email"
        element={<Confirmation />}
      />

      <Route
        path="create-family"
        element={<CreateFamily />}
      />

      <Route
        path="checkout"
        element={<Checkout />}
      />

      <Route
        path="customize-profile/:familyId"
        element={<CustomizeProfile />}
      />

      <Route
        path="create-pin"
        element={<CreatePin />}
      />

      <Route
        path="select-family"
        element={<SelectFamilyComponent />}
      />

      <Route
        path="change-subscription"
        element={<ChangeSubscription />}
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  </SignInUpPage>
);
